<template>
	<div class="flex h-screen w-screen items-center justify-center">
		<slot />
	</div>
</template>

